<template>
  <div id="actualContainer">
    <v-container class="pa-2">
      <v-row class="mt-6 mb-10">
        <v-col lg="4" v-for="(item, idx) in actual" :key="idx">
          <InfoCard :cardData="item" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import InfoCard from "../components/Shared/InfoCard";
import { db } from "@/main";

export default {
  components: {
    InfoCard
  },
  data() {
    return {
      actual: []
    };
  },
  firestore() {
    return {actual: db.collection('Actual')};
  }
};
</script>

<style scoped>
</style>